import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormHelperText from '@material-ui/core/FormHelperText';

const pageStyles = theme => ({
  optionalMessage: {
    fontSize: 18,
  },
});

function TextArea({ label, helperText, required, classes, className, labelClassName, ...props }) {
  return (
    <FormControl>
      <InputLabel className={labelClassName} htmlFor={`textarea-${label}`} {...props}>
        {label} {required ? '*' : <span className={classes.optionalMessage}>(optional)</span>}
      </InputLabel>
      <textarea id={`textarea-${label}`} {...props} className={className} ref={props.inputRef}></textarea>
      {helperText && <FormHelperText {...props}>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default withStyles(pageStyles)(TextArea);
